import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DxLoadPanelModule, DxPopupModule, DxValidatorModule } from 'devextreme-angular';
import { ProductionReportViewerPageComponent } from './production-report-viewer-page.component';
import { ReportSettingsFormModule } from './report-settings-form/report-settings-form.module';
import { ProductionReportViewModule } from './production-report-view/production-report-view.module';

@NgModule({
  declarations: [ProductionReportViewerPageComponent],
  imports: [
    CommonModule,
    RouterModule,
    DxPopupModule,
    DxLoadPanelModule,
    DxValidatorModule,
    ReportSettingsFormModule,
    ProductionReportViewModule,
  ],
  exports: [ProductionReportViewerPageComponent, ProductionReportViewModule, ReportSettingsFormModule],
})
export class ProductionReportViewerModule {}
